import { api } from './api';

export interface PublishRequestRequesterDto {
  userId: string;
  name: string;
  email: string;
}

export interface PrivateDocumentSummaryForPublishDto {
  id: string;
  fileName: string;
  fileType: string;
  fileSizeBytes: number;
}

export interface PendingDocumentPublishRequestDto {
  id: string;
  userPrivateDocumentId: string;
  targetDocumentId?: string | null;
  notes?: string | null;
  createdAt: string;
  requestedBy: PublishRequestRequesterDto;
  privateDocument: PrivateDocumentSummaryForPublishDto;
}

export interface ReviewDocumentPublishRequestBody {
  approve: boolean;
  targetDocumentId?: string | null;
  notes?: string | null;
}

export interface ReviewDocumentPublishRequestResultDto {
  publishRequestId: string;
  status: string;
  publicDocumentId?: string | null;
  notes?: string | null;
}

class DocumentPublishRequestService {
  async listPending(): Promise<PendingDocumentPublishRequestDto[]> {
    const response = await api.get<PendingDocumentPublishRequestDto[]>('/publish-requests');
    return response.data ?? [];
  }

  async review(
    id: string,
    body: ReviewDocumentPublishRequestBody
  ): Promise<ReviewDocumentPublishRequestResultDto> {
    const response = await api.put<ReviewDocumentPublishRequestResultDto>(
      `/publish-requests/${id}/review`,
      body
    );
    return response.data;
  }
}

export const documentPublishRequestService = new DocumentPublishRequestService();
